'use client';

import { WithDefaultLayout } from '@/components/DefautLayout';
import React, { useState, useEffect } from 'react';
import { articles } from '@/constants';
import { Article } from '@/interfaces/Article';
import SearchFilterBar from '@/components/blog/SearchFilterBar';
import LatestArticle from '@/components/blog/LatestArticle';
import SidebarArticles from '@/components/blog/SidebarArticles';
import ArticleCarousel from '@/components/blog/ArticleCarousel';
import { useSearchParams } from 'next/navigation';
import { Title } from '@/components/Title';

const categories = ['Coding', 'Robotic', 'Artificial Intelligence (AI)', 'Digital Marketing', 'Bahasa Jepang','Competitive Programming'];

const BlogPage = () => {
    const [selectedCategory, setSelectedCategory] = useState<string>('Semua');

    const searchParams = useSearchParams();
    const categoryFromUrl = searchParams.get('category');

    useEffect(() => {
        if (categoryFromUrl && categories.includes(categoryFromUrl)) {
            setSelectedCategory(categoryFromUrl);
        }
    }, [categoryFromUrl]);

    const sortedArticles: Article[] = [...articles].sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

    const filteredArticles =
        selectedCategory === 'Semua'
            ? sortedArticles
            : sortedArticles.filter((article) => article.category === selectedCategory);

    const latestArticle = filteredArticles[0];
    const sidebarArticles = filteredArticles.slice(1, 5);

    if (!latestArticle) {
        return (
            <div className="px-6 md:px-16 py-10 font-sans">
                <h2 className="text-xl font-bold">Tidak ada artikel pada kategori ini.</h2>
            </div>
        );
    }

    return (
        <>
        <Title title={'Blog'} description='' />
            <SearchFilterBar
                categories={categories}
                selectedCategory={selectedCategory}
                onSelectCategory={setSelectedCategory}
                articles={articles}
            />

            <div className="px-6 md:px-16 py-10 font-sans">
                <div className="flex flex-col md:flex-row gap-6">
                    <LatestArticle article={latestArticle} />
                    <SidebarArticles articles={sidebarArticles} />
                </div>

            </div>
            <ArticleCarousel articles={filteredArticles} />
        </>
    );
};

BlogPage.layout = WithDefaultLayout;
export default BlogPage;